'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function CDFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-0785ssj33", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-2tvafsqxv", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-qqubzq9h2" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-qqubzq9h2", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-0785ssj33)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3195f9", xlinkHref: "#mantine-qqubzq9h2" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#e31d1c",
        fillRule: "nonzero",
        stroke: "#feca00",
        strokeWidth: "2.5",
        d: "M33.604-4.519L37.213.887-1.127 26.48l-3.61-5.406z",
        mask: "url(#mantine-2tvafsqxv)"
      }
    ), /* @__PURE__ */ React.createElement("g", { fill: "#feca00", mask: "url(#mantine-2tvafsqxv)" }, /* @__PURE__ */ React.createElement("path", { d: "M4.93 8.606l-3.485 2.418 1.114-4.141L0 4.238l3.465-.143L4.93 0l1.466 4.095h3.458L7.302 6.883l1.279 3.897z" }))))
  );
}

export { CDFlag };
//# sourceMappingURL=CD.mjs.map
